export const ARTICLES_PER_PAGE = 9;
export const TRUNCATE_LIMIT = 70;

export const CATEGORIES = ['all', 'diet', 'workouts', 'tips'];

// for analytics purposes
export const CATEGORY_AS_NUMBER = {
  all: 0,
  diet: 1,
  workouts: 3,
  tips: 4,
};

// for i18n-unused
// t('feed.all')
// t('feed.excercise')
// t('feed.tips')
// t('feed.diet')
